module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "container"
  }, [(_vm.fill_info == '' && _vm.subpage == 'data') ? _c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('inputbox', {
    attrs: {
      "id": "nev",
      "label": "Viselt neve <span style='font-size: 10px; display: block; font-weight: 400'>(A dr-i, egyéb nevére vonatkozó előtagokat, a neve után vesszővel elválasztva tüntesse fel)</span>",
      "name": "nev",
      "regexp_filter": "[a-zA-ZöüóőúéáűíÖÜÓŐÚÉÁŰÍ. ,]+",
      "errors": _vm.errors
    },
    model: {
      value: (_vm.form.nev),
      callback: function($$v) {
        _vm.form.nev = $$v
      },
      expression: "form.nev"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('inputbox', {
    attrs: {
      "id": "email",
      "label": "E-mail cím",
      "name": "email",
      "errors": _vm.errors
    },
    model: {
      value: (_vm.form.email),
      callback: function($$v) {
        _vm.form.email = $$v
      },
      expression: "form.email"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('inputbox', {
    attrs: {
      "id": "mobilszam",
      "label": "Mobilszám",
      "mask": "+99 99 / 999 9999",
      "regexp_filter": "[0-9]+",
      "name": "mobilszam",
      "errors": _vm.errors
    },
    model: {
      value: (_vm.form.mobilszam),
      callback: function($$v) {
        _vm.form.mobilszam = $$v
      },
      expression: "form.mobilszam"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('inputbox', {
    attrs: {
      "disabled": true,
      "id": "neptunkod",
      "label": "Neptunkód",
      "name": "neptunkod",
      "errors": _vm.errors
    },
    model: {
      value: (_vm.form.neptunkod),
      callback: function($$v) {
        _vm.form.neptunkod = $$v
      },
      expression: "form.neptunkod"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "info-box download",
    staticStyle: {
      "margin": "20px 0px"
    }
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": 'assets/files/ekop_kdp_' + _vm.felev_kod + '_sablon.docx',
      "title": "Egyetemi Kutatói Ösztöndíj Program Kooperatív Doktori Program szakmai beszámoló sablon letöltés"
    }
  }, [_c('span', {
    staticClass: "highlight"
  }, [_vm._v("Egyetemi Kutatói Ösztöndíj Program Kooperatív Doktori Program szakmai beszámoló sablon")]), _vm._v(" letöltés\n          ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('UploadHandler', {
    attrs: {
      "max_uploaded_files": "1",
      "accepted_files": "application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      "errors": _vm.errors,
      "id": "szakmai_beszamolo_szerkesztheto",
      "label": "Szakmai beszámoló szerkeszthető változat <span style='font-size: 10px; display: block; font-weight: 400'>(Legalább 3000 karakter szükséges. A fájl elnevezése az ösztöndíjas előtagok nélküli neve és EKÖP-KDP Szakmai Beszámoló_szerk. legyen.)</span>",
      "name": "szakmai_beszamolo_szerkesztheto",
      "loaded_files": _vm.form.szakmai_beszamolo_szerkesztheto
    },
    on: {
      "change": function (value) {
        _vm.form.szakmai_beszamolo_szerkesztheto = value;
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('UploadHandler', {
    attrs: {
      "max_uploaded_files": "1",
      "accepted_files": "image/jpeg,application/pdf,application/x-pdf",
      "errors": _vm.errors,
      "id": "szakmai_beszamolo",
      "label": "Szakmai beszámoló aláírva, szkennelve <span style='font-size: 10px; display: block; font-weight: 400'>(Legalább 3000 karakter szükséges. A fájl elnevezése az ösztöndíjas előtagok nélküli neve és EKÖP-KDP Szakmai Beszámoló legyen.)</span>",
      "name": "szakmai_beszamolo",
      "loaded_files": _vm.form.szakmai_beszamolo
    },
    on: {
      "change": function (value) {
        _vm.form.szakmai_beszamolo = value;
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('UploadHandler', {
    attrs: {
      "max_uploaded_files": "1",
      "accepted_files": "application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      "errors": _vm.errors,
      "id": "fogado_doktori_iskola_ertekelese_szerkesztheto",
      "label": "Fogadó doktori iskola értékelése szerkeszthető változat <span style='font-size: 10px; display: block; font-weight: 400'>(Legalább 2000 karakter szükséges. A fájl elnevezése az ösztöndíjas előtagok nélküli neve és EKÖP-KDP Fogadó Doktori Iskola Értékelés_szerk. legyen.)</span>",
      "name": "fogado_doktori_iskola_ertekelese_szerkesztheto",
      "loaded_files": _vm.form.fogado_doktori_iskola_ertekelese_szerkesztheto
    },
    on: {
      "change": function (value) {
        _vm.form.fogado_doktori_iskola_ertekelese_szerkesztheto = value;
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('UploadHandler', {
    attrs: {
      "max_uploaded_files": "1",
      "accepted_files": "image/jpeg,application/pdf,application/x-pdf",
      "errors": _vm.errors,
      "id": "fogado_doktori_iskola_ertekelese",
      "label": "Fogadó doktori iskola értékelése aláírva, szkennelve <span style='font-size: 10px; display: block; font-weight: 400'>(Legalább 2000 karakter szükséges. A fájl elnevezése az ösztöndíjas előtagok nélküli neve és EKÖP-KDP Fogadó Doktori Iskola Értékelés legyen.)</span>",
      "name": "fogado_doktori_iskola_ertekelese",
      "loaded_files": _vm.form.fogado_doktori_iskola_ertekelese
    },
    on: {
      "change": function (value) {
        _vm.form.fogado_doktori_iskola_ertekelese = value;
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('UploadHandler', {
    attrs: {
      "max_uploaded_files": "1",
      "accepted_files": "application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      "errors": _vm.errors,
      "id": "temavezetoi_ertekeles_szerkesztheto",
      "label": "Témavezetői értékelés szerkeszthető változat <span style='font-size: 10px; display: block; font-weight: 400'>(Legalább 2000 karakter szükséges. A fájl elnevezése az ösztöndíjas előtagok nélküli neve és EKÖP-KDP Témavezetői Értékelés_szerk. legyen.)</span>",
      "name": "temavezetoi_ertekeles_szerkesztheto",
      "loaded_files": _vm.form.temavezetoi_ertekeles_szerkesztheto
    },
    on: {
      "change": function (value) {
        _vm.form.temavezetoi_ertekeles_szerkesztheto = value;
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('UploadHandler', {
    attrs: {
      "max_uploaded_files": "1",
      "accepted_files": "image/jpeg,application/pdf,application/x-pdf",
      "errors": _vm.errors,
      "id": "temavezetoi_ertekeles",
      "label": "Témavezetői értékelés aláírva, szkennelve <span style='font-size: 10px; display: block; font-weight: 400'>(Legalább 2000 karakter szükséges. A fájl elnevezése az ösztöndíjas előtagok nélküli neve és EKÖP-KDP Témavezetői Értékelés legyen.)</span>",
      "name": "temavezetoi_ertekeles",
      "loaded_files": _vm.form.temavezetoi_ertekeles
    },
    on: {
      "change": function (value) {
        _vm.form.temavezetoi_ertekeles = value;
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('UploadHandler', {
    attrs: {
      "max_uploaded_files": "1",
      "accepted_files": "application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      "errors": _vm.errors,
      "id": "vallalati_szakerto_ertekelese_szerkesztheto",
      "label": "Vállalati szakértő értékelés szerkeszthető változat <span style='font-size: 10px; display: block; font-weight: 400'>(Legalább 2000 karakter szükséges. A fájl elnevezése az ösztöndíjas előtagok nélküli neve és EKÖP-KDP Vállalati Szakértő Értékelés_szerk. legyen.)</span>",
      "name": "vallalati_szakerto_ertekelese_szerkesztheto",
      "loaded_files": _vm.form.vallalati_szakerto_ertekelese_szerkesztheto
    },
    on: {
      "change": function (value) {
        _vm.form.vallalati_szakerto_ertekelese_szerkesztheto = value;
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('UploadHandler', {
    attrs: {
      "max_uploaded_files": "1",
      "accepted_files": "image/jpeg,application/pdf,application/x-pdf",
      "errors": _vm.errors,
      "id": "vallalati_szakerto_ertekelese",
      "label": "Vállalati szakértő értékelés aláírva, szkennelve <span style='font-size: 10px; display: block; font-weight: 400'>(Legalább 2000 karakter szükséges. A fájl elnevezése az ösztöndíjas előtagok nélküli neve és EKÖP-KDP Vállalati Szakértő Értékelés legyen.)</span>",
      "name": "vallalati_szakerto_ertekelese",
      "loaded_files": _vm.form.vallalati_szakerto_ertekelese
    },
    on: {
      "change": function (value) {
        _vm.form.vallalati_szakerto_ertekelese = value;
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('UploadHandler', {
    attrs: {
      "max_uploaded_files": "1",
      "accepted_files": "image/jpeg,application/pdf,application/x-pdf",
      "errors": _vm.errors,
      "id": "konzultacios_lap",
      "label": "Konzultációs lap aláírva, szkennelve <span style='font-size: 10px; display: block; font-weight: 400'>(A fájl elnevezése az ösztöndíjas előtagok nélküli neve és EKÖP-KDP Konzultációs lap legyen.)</span>",
      "name": "konzultacios_lap",
      "loaded_files": _vm.form.konzultacios_lap
    },
    on: {
      "change": function (value) {
        _vm.form.konzultacios_lap = value;
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('UploadHandler', {
    attrs: {
      "max_uploaded_files": "1",
      "accepted_files": "image/jpeg,application/pdf,application/x-pdf",
      "errors": _vm.errors,
      "id": "publikacios_es_szabadalmi_teljesitmeny",
      "label": "Publikációs és szabadalmi teljesítmény bemutatása aláírva, szkennelve <span style='font-size: 10px; display: block; font-weight: 400'>(A fájl elnevezése az ösztöndíjas előtagok nélküli neve és EKÖP-KDP Publikációs És Szabadalmi Teljesítmény Bemutatása legyen.)</span>",
      "name": "publikacios_es_szabadalmi_teljesitmeny",
      "loaded_files": _vm.form.publikacios_es_szabadalmi_teljesitmeny
    },
    on: {
      "change": function (value) {
        _vm.form.publikacios_es_szabadalmi_teljesitmeny = value;
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between",
      "align-items": "center"
    }
  }, [_c('button', {
    staticClass: "button",
    attrs: {
      "disabled": _vm.saving,
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.save(1)
      }
    }
  }, [_vm._v("Mentés")]), _vm._v(" "), _c('button', {
    staticClass: "button",
    attrs: {
      "disabled": _vm.saving,
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.save(2)
      }
    }
  }, [_vm._v("Véglegesít")])])])]) : _vm._e(), _vm._v(" "), (_vm.fill_info != '') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-title"
  }, [_vm._v("Egyetemi Kutatói Ösztöndíj Program Kooperatív Doktori Program szakmai beszámoló")]), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.fill_info)
    }
  })])]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-title"
  }, [_vm._v("Egyetemi Kutatói Ösztöndíj Program Kooperatív Doktori Program szakmai beszámoló")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1238302b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/competition/ekop_kdp_szakmai_beszamolo.vue
// module id = 326
// module chunks = 0